import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {HttpClient} from '@angular/common/http';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {Observable} from 'rxjs';
import {AppUrl} from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class MessengerLeadService extends BaseService {

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  add(data: {}): Observable<any> {
    return this.postRequest(AppUrl.MESSENGER_LEAD(), data);
  }

  get(data: {}): Observable<any> {
    return this.getRequestWithoutErrorMessage(AppUrl.MESSENGER_LEAD(), data);
  }

  detail(uniqueId: any): Observable<any> {
    return this.getRequest(AppUrl.MESSENGER_LEAD(uniqueId));
  }

  delete(uniqueId: any): Observable<any> {
    return this.deleteRequest(AppUrl.MESSENGER_LEAD(uniqueId));
  }

  update(data: {}, uniqueId: any): Observable<any> {
    return this.putRequest(AppUrl.MESSENGER_LEAD(uniqueId), data);
  }

  assignAgent(data: {}): Observable<any> {
    return this.putRequest(AppUrl.MESSENGER_LEAD_ASSIGN(), data);
  }

  addFollowUp(uniqueId, data: {}): Observable<any> {
    return this.putRequest(AppUrl.MESSENGER_LEAD_FOLLOW_UP(uniqueId), data);
  }

  status(data: {}, uniqueId: any): Observable<any> {
    return this.putRequest(AppUrl.MESSENGER_LEAD_STATUS(uniqueId), data);
  }

  count(): Observable<any> {
    return this.getRequest(AppUrl.MESSENGER_LEAD_COUNT());
  }

  downloadMessengerLeadReport(data: {}): Observable<any> {
    return this.getRequest(AppUrl.MESSENGER_LEAD_DOWNLOAD_REPORT(), data);
  }
}
